var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"href":'mailto:' + _vm.email + '?subject=' + _vm.subjectLine,"v:on-click":"showAlert"}},[_vm._v(" Support")])}
var staticRenderFns = []

export { render, staticRenderFns }